import EcoTitle from 'eco-design/base/eco-title';
import styles from './index.module.scss';
import { useLang } from '@/i18n';
import { useEffect, useState } from 'react';
import { getIsPadWidth } from '@elem/utils/devices';
import PC from './pc';
import H5 from './h5';
import EcoSpace from 'eco-design/base/eco-space';

export default function Comp() {
    const { t } = useLang('theProduct.Animation1');

    const [isPad, setIsPad] = useState(getIsPadWidth());
    useEffect(() => {
        setIsPad(getIsPadWidth());
    }, []);

    return (
        <>
            <EcoSpace />
            <div className={styles.title} id="wave3-D-title">
                <EcoTitle title={t('title')} />
            </div>
            {isPad ? <H5 /> : <PC />}
        </>
    );
}
